@for (rule of rules; track rule) {
  @if (invalid(rule)) {
    <rask-validation-message-row
      [message]="rule.settings.message.text"
      [type]="getRuleType(rule)"
      >
    </rask-validation-message-row>
  }
}
